import { Button, Typography } from '@heroui/react'
import { createLink } from '@tanstack/react-router'
import { useCurrentUser } from '@zealth/core/firebase/authStore'
import { FileQuestion } from 'lucide-react'

const LinkButton = createLink(Button)

const NotFoundPage = () => {
  const user = useCurrentUser()
  const homePath = user ? '/dashboard' : '/'

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <FileQuestion
        size={72}
        strokeWidth={1.5}
        className="text-foreground-400 mb-4"
      />

      <Typography.Heading level={1} className="mb-2">
        Off the beaten path
      </Typography.Heading>

      <Typography.Paragraph color="muted" className="max-w-md mb-8">
        This page isn't on the map. Let's get you back to base camp.
      </Typography.Paragraph>

      <LinkButton to={homePath} replace>
        Back home
      </LinkButton>
    </div>
  )
}

export default NotFoundPage
